import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, Zap, MapPin } from 'lucide-react';
export function HeaderHero() {
  return <div className="w-full" data-id="element-51">
      {/* Hero Section */}
      <section className="relative bg-slate-900 text-white pt-12 pb-16 sm:pt-20 sm:pb-24 overflow-hidden" data-id="element-52">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600" data-id="element-53"></div>

        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-54">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center text-center" data-id="element-55">
            <span className="inline-block py-1 px-3 rounded-full bg-teal-900/50 text-teal-300 text-xs sm:text-sm font-semibold tracking-wide border border-teal-800 mb-3 sm:mb-4" data-id="element-56">
              Radioterapeutas · Residentes y especialistas
            </span>
            <h1 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-tight mb-5 sm:mb-7" data-id="element-57">
              Toda tu comunicación con pacientes oncológicos,{' '}
              <span className="text-teal-400" data-id="element-58">resuelta</span>
            </h1>

            {/* Mockup principal (70%) */}
            <div className="relative w-[70%] max-w-md mx-auto mb-2" data-id="element-59">
              <div className="absolute inset-0 bg-teal-500 rounded-full blur-3xl opacity-20 animate-pulse" data-id="element-60"></div>
              <img src="https://cdn.magicpatterns.com/uploads/bHWi8qrQFMwCY4hKtaW1mU/MOCKUP_SIN_FONDO.png" alt="Megapack de Comunicación Oncológica Mockup" width={900} height={900} loading="eager" fetchPriority="high" decoding="async" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-61" />
            </div>
            <p className="text-[11px] sm:text-xs text-slate-500 font-medium tracking-wide mb-5 sm:mb-7" data-id="element-62">
              Megapack de Comunicación Oncológica para el Radioterapeuta — 8
              Tomos + 3 Bonos
            </p>

            <p className="text-base sm:text-lg text-slate-400 leading-relaxed mb-6 sm:mb-8" data-id="element-63">
              Tu sistema completo listo para usar: guiones de consulta,
              consentimientos en lenguaje llano, plantillas por tipo de tumor,
              manejo de efectos adversos y protocolos para las conversaciones
              más difíciles de la especialidad. Explicá cualquier plan de
              tratamiento en 5 minutos. Sin improvisar.
            </p>

            <div className="w-full space-y-4" data-id="element-64">
              <motion.a href="#comprar-megapack" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="block w-full sm:w-auto sm:mx-auto text-center bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold text-base sm:text-lg py-3 sm:py-4 px-6 sm:px-8 rounded-xl shadow-lg shadow-amber-500/20 transition-colors" data-id="element-65">
                💥 QUIERO MI COMUNICACIÓN RESUELTA
              </motion.a>

              <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 text-xs sm:text-sm text-slate-400 font-medium" data-id="element-66">
                <div className="flex items-center gap-1.5" data-id="element-67">
                  <ShieldCheck className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-teal-400" data-id="element-68" />{' '}
                  Garantía 7 días
                </div>
                <div className="flex items-center gap-1.5" data-id="element-69">
                  <CreditCard className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-teal-400" data-id="element-70" />{' '}
                  Pago seguro Mercado Pago
                </div>
                <div className="flex items-center gap-1.5" data-id="element-71">
                  <Zap className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-teal-400" data-id="element-72" />{' '}
                  Acceso inmediato
                </div>
                <div className="flex items-center gap-1.5" data-id="element-73">
                  <MapPin className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-teal-400" data-id="element-74" />{' '}
                  Todo Argentina
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}